/*
    Not Access View
    Extends ItemView
*/

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/no-access.hbs';

    var NoAccessView = Marionette.View.extend({
        template: Handlebars.compile(template),
        className : 'no-access',
        id : "ide-container",
        templateContext: function(){
            return this.options;
        }
    });

    export default NoAccessView;

